export const PRODUCT_LIST_API = '/api/products/';
export const PRODUCT_DETAIL_API = '/api/products/product/';
export const CATEGORY_LIST_API = '/api/categories/index';
export const SUBCATEGORY_LIST_API = '/api/categories/';
export const FEATURED_PRODUCT_API = '/api/products/featured/';

export function updateMetaTitle(str) {
  document.title = str + ' | ' + window.oakleys.metaTitle;
}
